module.exports = __webpack_public_path__ + "img/tagid.e5f8190f.jpg";